import React from 'react';
import Banner from "../base/Banner";
import GlobalRegisterComponent from "./GlobalRegisterComponent";
import getCustomerData, { getPositionList } from '../../services/DataGetter';
import {setLanguage} from "../../enums/Languages";
import { Redirect } from 'react-router';

class GlobalRegister extends React.PureComponent
{
    constructor(props){
        super(props);
        if (this.props.match.params['source']) {
            sessionStorage.setItem('source', this.props.match.params['source']);
            window.history.pushState(null, '', window.location.href.split(this.props.match.params['source'])[0]);
        }
        this.state = {
            step: 1,
            language: setLanguage(this.props.match.params['lang']),
            customerData: getCustomerData(this.props.match.params['customerName']),
			globalGate: true,
            userName: sessionStorage.getItem('userName-' +this.props.match.params['customerName'])
        };
        this.setGlobalGate();
    }

	setGlobalGate = async () => {
    	getPositionList(this.props.match.params['customerName']).then(response => {
    		this.setState({globalGate: response.globalGate})});
	}

    setBannerData = (userName) => {
        this.setState({userName: userName});
        this.forceUpdate();
    };



    render(){
        const {userName, language} = this.state;

        return (
            <>
				{this.state.globalGate || <Redirect to={'/gate/' + this.props.match.params['customerName']} />}
                <Banner
                    customerName={this.props.match.params['customerName']}
                    language={language}
                    userName={userName}
                    customerData={this.state['customerData']}
                />
                <GlobalRegisterComponent
                    customerName={this.props.match.params['customerName']}
                    language={language}
                    setBannerData={this.setBannerData}
                    customerData={this.state['customerData']}
                />
            </>
        );
    }
}

export default GlobalRegister;
